"use client";

import React from "react";
import { Popconfirm, Input, Divider } from "antd";
import { PlusCircleOutlined } from "@ant-design/icons";

const CreatePopconfirm = ({
  openPop,
  caption,
  onChangeInputDriver,
  handleOk,
  confirmLoading,
  handleCancel_pro,
  disabled,
}) => {
  if (disabled) return null;

  return (
    <Popconfirm
      icon={<PlusCircleOutlined />}
      title={caption}
      description={
        <div style={{ margin: 20 }}>
          <Divider>{caption}</Divider>
          <Input
            onChange={onChangeInputDriver}
            style={{ width: "300px", height: 40 }}
            placeholder="Input value..."
          />
        </div>
      }
      open={openPop}
      onConfirm={handleOk}
      okButtonProps={{ loading: confirmLoading }}
      onCancel={handleCancel_pro}
    >
      <></>
    </Popconfirm>
  );
};

export default CreatePopconfirm;
